import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import { BenefitDateCell } from 'src/modules/benefits/components/benefit-table-cells';
import AchievementStatusBadge from 'src/modules/trails/components/achievement-status-badge';
import { formatBenefitDate as formatDate } from 'src/utils/benefit-dates';
import { LPUserTextCell } from '../../components/lp-users-table/lp-users-table-cells';

export const LP_EVENT_COLUMNS: GridColDef[] = [
  { field: 'name', headerName: 'Nome', minWidth: 220, flex: 1.2 },
  { field: 'detail', headerName: 'Detalhe', minWidth: 200, flex: 1 },
  ...['startDate', 'endDate', 'editedAt'].map((field): GridColDef => ({
    field,
    headerName: { startDate: 'Data de início', endDate: 'Data de fim', editedAt: 'Atualizado em' }[
      field
    ],
    type: 'date',
    minWidth: 170,
    valueGetter: ({ value }) => (value ? new Date(value) : null),
    valueFormatter: ({ value }) => formatDate(value instanceof Date ? value.toJSON() : value),
    renderCell: ({ value }) => <BenefitDateCell value={value} formatDate={formatDate} />,
  })),
  { field: 'editedByName', headerName: 'Atualizado por', minWidth: 200, flex: 1 },
  {
    field: 'status',
    headerName: 'Status',
    minWidth: 130,
    renderCell: ({ value }: GridRenderCellParams) => (
      <AchievementStatusBadge status={value} variant="soft" />
    ),
  },
].map((column) => ({
  align: 'left',
  headerAlign: 'left',
  disableColumnMenu: true,
  renderCell: ({ value }: GridRenderCellParams) => <LPUserTextCell value={value} />,
  ...column,
}));
